import { useMutation, useQueries, useQueryClient } from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { fetchSalaryWorkers } from "./salaryWorkers";

const fetchDeductions = async (year: any, companyId: any) => {
  return await axios({
    method: "get",
    url: SERVICES.DEDUCTIONS,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
    },
  }).then((res) => res.data || []);
};

export const usePromiseSettledDeductions = (year: any) => {
  const companyId = getCompanyId();
  const queryConfig = {
    staleTime: 300,
    cacheTime: 300,
    // retry: 1,
    enabled: !!year,
  };

  return useQueries({
    queries: [
      {
        queryKey: ["QUERY_NAME.DEDUCTIONS", 1, year, companyId],
        queryFn: () => fetchDeductions(year, companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.DEDUCTIONS", 2, year, companyId],
        queryFn: () => fetchSalaryWorkers(companyId),
        ...queryConfig,
      },
    ],
  });
};

export const useSubmitDeductions = (controller: any) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axios({
        method: "post",
        url: SERVICES.DEDUCTIONS_SAVE,
        data: payload,
        ...(controller && { signal: controller?.signal }),
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.DEDUCTIONS]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
